(function () {
  const refreshVisionCartUI = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  };

  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(refreshVisionCartUI, 150);
  });

  document.addEventListener('rebuy:cart.add', () => {
    setTimeout(refreshVisionCartUI, 150);
  });
})();
(function () {
  // Flip this flag only when we believe the user initiated an add-to-cart
  let shouldOpenDrawer = false;

  // Track clicks inside Rebuy bundle builder on likely "add" buttons
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button, a, input[type="submit"]');
    if (!btn) return;

    // Only consider clicks inside Rebuy widgets
    const inRebuy = btn.closest('.rebuy-widget, .rebuy-bundle-builder');
    if (!inRebuy) return;

    const text = (btn.textContent || '').trim().toLowerCase();

    // Match common CTA wording (adjust if yours differs)
    const looksLikeAdd =
      text.includes('add') ||
      text.includes('bundle') ||
      text.includes('checkout') ||
      text.includes('continue');

    if (looksLikeAdd) {
      shouldOpenDrawer = true;

      // Safety: auto-reset in case no cart event fires
      setTimeout(() => { shouldOpenDrawer = false; }, 3000);
    }
  }, true);

  const refreshVisionCartUI = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  };

  const openCartDrawer = () => {
    // Try common Vision/Fuel Themes triggers first
    const opener =
      document.querySelector('[data-cart-drawer-open]') ||
      document.querySelector('[href="/cart"][data-drawer-trigger]') ||
      document.querySelector('a[href="/cart"]');

    if (opener) opener.click();
  };

  // Rebuy signals: cart updated
  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(() => {
      refreshVisionCartUI();

      // Only open if the user clicked an "add bundle" CTA
      if (shouldOpenDrawer) {
        openCartDrawer();
      }

      shouldOpenDrawer = false;
    }, 150);
  });

  // Some setups fire add separately
  document.addEventListener('rebuy:cart.add', () => {
    setTimeout(() => {
      refreshVisionCartUI();

      if (shouldOpenDrawer) {
        openCartDrawer();
      }

      shouldOpenDrawer = false;
    }, 150);
  });
})();

(function () {
  const update = () => {
    const cartOpen = !!document.querySelector('cart-drawer.cart-drawer.active');
    document.body.classList.toggle('mini-cart-open', cartOpen);
  };

  update();

  // Watch for the drawer opening/closing (class changes)
  const obs = new MutationObserver(update);
  obs.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
})();

